(() => {
  const initialisePage = (page) => {
    if (!page || page.dataset.craveInitialised === 'true') return;
    page.dataset.craveInitialised = 'true';

    const stickyHeader = document.querySelector('.pkc-head');
    if (stickyHeader && stickyHeader.dataset.craveCompactInitialised !== 'true') {
      stickyHeader.dataset.craveCompactInitialised = 'true';
      const updateHeader = () => stickyHeader.classList.toggle('is-compact', window.scrollY > 90);
      window.addEventListener('scroll', updateHeader, { passive: true });
      updateHeader();
    }

    const track = page.querySelector('[data-gallery-track]');
    const slides = Array.from(page.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(page.querySelectorAll('[data-gallery-thumb]'));
    const counter = page.querySelector('[data-current-media]');

    if (track && slides.length) {
      let activeIndex = 0;
      let scrollFrame;

      const setActive = (index, shouldScroll = false) => {
        const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
        activeIndex = nextIndex;

        thumbs.forEach((thumb, thumbIndex) => {
          const selected = thumbIndex === activeIndex;
          thumb.classList.toggle('is-active', selected);
          thumb.setAttribute('aria-pressed', String(selected));
        });

        if (counter) counter.textContent = String(activeIndex + 1).padStart(2, '0');

        if (shouldScroll) {
          track.scrollTo({ left: track.clientWidth * activeIndex, behavior: 'smooth' });
        }
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          setActive(Number(thumb.dataset.mediaIndex || 0), true);
        });
      });

      track.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            if (!track.clientWidth) return;
            setActive(Math.round(track.scrollLeft / track.clientWidth));
          });
        },
        { passive: true }
      );

      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActive(activeIndex + 1, true);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActive(activeIndex - 1, true);
        }
      });

      window.addEventListener('resize', () => {
        track.scrollTo({ left: track.clientWidth * activeIndex, behavior: 'auto' });
      });
    }

    const productForm = page.querySelector('.crave-v4__product-form');
    const addButton = page.querySelector('.crave-v4__add-button');
    const purchaseBlock = page.querySelector('.crave-v4__product-purchase');
    const stickyBuyBar = page.querySelector('[data-sticky-buy-bar]');
    const stickyBuyButton = page.querySelector('[data-sticky-buy-button]');

    if (purchaseBlock && stickyBuyBar) {
      let stickyFrame;
      const updateStickyBuy = () => {
        window.cancelAnimationFrame(stickyFrame);
        stickyFrame = window.requestAnimationFrame(() => {
          const shouldShow = purchaseBlock.getBoundingClientRect().bottom < 0;
          stickyBuyBar.classList.toggle('is-visible', shouldShow);
          stickyBuyBar.setAttribute('aria-hidden', String(!shouldShow));
          page.classList.toggle('is-sticky-buy-visible', shouldShow);
        });
      };

      window.addEventListener('scroll', updateStickyBuy, { passive: true });
      window.addEventListener('resize', updateStickyBuy);
      updateStickyBuy();
    }

    if (stickyBuyButton && productForm && addButton) {
      stickyBuyButton.addEventListener('click', () => {
        productForm.requestSubmit(addButton);
      });
    }

    if (productForm && addButton) {
      productForm.addEventListener('submit', async (event) => {
        if (addButton.disabled || addButton.getAttribute('aria-busy') === 'true') return;
        event.preventDefault();
        addButton.setAttribute('aria-busy', 'true');
        addButton.textContent = 'Taking you to checkout…';

        const root = window.Shopify?.routes?.root || '/';
        try {
          const variantInput = productForm.querySelector('[name="id"]');
          const quantityInput = productForm.querySelector('[name="quantity"]');
          const items = [
            {
              id: Number(variantInput?.value),
              quantity: Number(quantityInput?.value || 1)
            }
          ];

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items })
          });

          if (!response.ok) throw new Error('Unable to add product');
          window.location.assign(`${root}checkout`);
        } catch (error) {
          addButton.removeAttribute('aria-busy');
          addButton.textContent = 'Buy now';
          productForm.submit();
        }
      });
    }
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-crave-emmie-page]').forEach(initialisePage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
